import { useState } from "react";
import ReportSelector from "../components/ReportSelector";
import ProfileForm from "../components/ProfileForm";
import Modal from "../components/Modal";
import "../styles/Info.css";

const Info = () => {
  const [selectedSection, setSelectedSection] = useState("welcome");

  return (
    <div className="content">
      <p>Informacoes</p>
   
      <Modal />
    </div>
  );
};

export default Info;
